var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecificexp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 4.66667H16.9167V2.33333C16.9167 1.03833 15.8412 0 14.5 0H9.66667C8.32542 0 7.25 1.03833 7.25 2.33333V4.66667H2.41667C1.07542 4.66667 0.0120833 5.705 0.0120833 7L0 19.8333C0 21.1283 1.07542 22.1667 2.41667 22.1667H21.75C23.0912 22.1667 24.1667 21.1283 24.1667 19.8333V7C24.1667 5.705 23.0912 4.66667 21.75 4.66667ZM9.66667 2.33333H14.5V4.66667H9.66667V2.33333ZM21.75 19.8333H2.41667V7H21.75V19.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecificexp);
export default __webpack_public_path__ + "static/media/Specificexp.8cf4aab38f729e9425ed271109afc3b1.svg";
export { ForwardRef as ReactComponent };